import { registerAction } from '../../Action'

const ADD_WORKFLOW_TO_CONTENT = 'ADD_WORKFLOW_TO_CONTENT'

const reducer = (state = {}, action) => {
  const data = action.payload.data
  const contentId = data.relationships.content.data.id
  const id = data.attributes.id
  const workflowStartedAt = data.attributes.workflow_started_at
  const entities = state.jsonApiEntities
  const entity =
    state.jsonApiEntities.content[contentId] ||
    state.jsonApiEntities.contents[contentId]

  const workflow = {
    id,
    type: 'phase-groups',
    workflow_started_at: workflowStartedAt,
  }

  return {
    ...state,
    jsonApiEntities: {
      ...entities,
      content: {
        ...entities.content,
        [contentId]: {
          ...entity,
          relationships: {
            ...entity.relationships,
            approval_phase_group: workflow,
          },
        },
      },
    },
  }
}

const addWorkflowToContent = registerAction(ADD_WORKFLOW_TO_CONTENT, {
  reducer,
})

export default addWorkflowToContent
